import {gql} from 'apollo-angular';

export const GET_BOOKMARK = gql`
  query GetBookmark($code: String!) {
    bookmarkGet(code: $code) {
      storedValue
    }
  }
`;
